module.exports = __webpack_public_path__ + "static/media/segoeui-semilight.7bf8c217.woff2";